import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { id: "address-list" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "form__duo-fields" }
const _hoisted_5 = { class: "form__submit btn btn--fullscreen" }

import {ref} from "vue"
import {useI18n} from "vue3-i18n"
import {notifyError} from "@/notify"
import {mustMatchPhoneNumberFormat, mustMatchZipCodeFormat, required} from "@/validation/rules"
import {Status} from "@/validation"
import {Contact} from "@/types/entities/contact"
import FormRow from "@/components/forms/FormRow.vue"
import FormInput from "@/components/forms/FormInput.vue"
import {IFilterAddressesRequest, IGetAddressRequest} from "@/types/requests";
import {IAddress} from "@/types/responses";
import {useAddressService} from "@/inversify.config";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ContactForm',
  props: {
    contact: {}
  },
  emits: ["formSubmit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// eslint-disable-next-line
const emit = __emit

const {t, getLocale} = useI18n()
const addressService = useAddressService()

const addressOptions = ref<IAddress[]>([])
const contact = ref<Contact>(props.contact ?? {})

const formInputs = ref<(typeof FormInput)[]>([])
const inputValidationStatuses: any = {}

function addFormInputRef(ref: typeof FormInput) {
  if (!formInputs.value.includes(ref))
    formInputs.value.push(ref)
}

async function handleValidation(name: string, validationStatus: Status) {
  inputValidationStatuses[name] = validationStatus.valid
}

async function handleSubmit() {
  formInputs.value.forEach((x: typeof FormInput) => x.validateInput())
  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }
  emit("formSubmit", contact.value)
}

async function handleInput(inputValue: string) {
  let selectedOptions = addressOptions.value.filter(x => x.text == inputValue)
  if (selectedOptions.length > 0) {
    let request = {
      id: selectedOptions[0].id,
      language: getLocale()
    } as IGetAddressRequest
    let response = await addressService.getAddress(request)
    contact.value.street = response.detailedAddress.street
    contact.value.city = response.detailedAddress.city
    contact.value.zipCode = response.detailedAddress.zipCode.replace(' ', '')
    return;
  }
  await loadMatchingAddresses(inputValue)
}

async function loadMatchingAddresses(inputValue: string) {
  let request = {
    street: inputValue,
    language: getLocale()
  } as IFilterAddressesRequest
  let addresses = await addressService.filterAddresses(request)
  addressOptions.value = addresses.matchingAddresses
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    novalidate: "",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _createVNode(FormRow, { withThreeColumns: true }, {
      default: _withCtx(() => [
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.firstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contact.value.firstName) = $event)),
          label: _unref(t)('global.firstName'),
          name: "firstName",
          type: "text",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.lastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contact.value.lastName) = $event)),
          label: _unref(t)('global.lastName'),
          name: "lastName",
          type: "text",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.jobTitle,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contact.value.jobTitle) = $event)),
          label: _unref(t)('global.jobTitle'),
          rules: [],
          name: "jobTitle",
          type: "text",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"])
      ]),
      _: 1
    }),
    _createVNode(FormRow, { withThreeColumns: true }, {
      default: _withCtx(() => [
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.apartment,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contact.value.apartment) = $event)),
          label: _unref(t)('global.apartment'),
          rules: [],
          name: "apartment",
          type: "text",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.street,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((contact.value.street) = $event)),
            handleInput
          ],
          label: _unref(t)('global.street'),
          list: 'address-list',
          name: "street",
          type: "text",
          onValidated: handleValidation
        }, {
          "before-input": _withCtx(() => [
            _createElementVNode("datalist", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressOptions.value, (address) => {
                return (_openBlock(), _createElementBlock("option", {
                  id: address.id,
                  key: address.id
                }, _toDisplayString(address.text), 9, _hoisted_3))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "label"]),
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.city,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((contact.value.city) = $event)),
          label: _unref(t)('global.city'),
          name: "city",
          type: "text",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"])
      ]),
      _: 1
    }),
    _createVNode(FormRow, { withThreeColumns: true }, {
      default: _withCtx(() => [
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.zipCode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contact.value.zipCode) = $event)),
          label: _unref(t)('global.zipCode'),
          rules: [_unref(required), _unref(mustMatchZipCodeFormat)],
          name: "zipCode",
          type: "zip",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label", "rules"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(FormInput, {
            ref: addFormInputRef,
            modelValue: contact.value.phoneNumber,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((contact.value.phoneNumber) = $event)),
            label: _unref(t)('global.phoneNumber'),
            rules: [_unref(required), _unref(mustMatchPhoneNumberFormat)],
            name: "phoneNumber",
            type: "tel",
            onValidated: handleValidation
          }, null, 8, ["modelValue", "label", "rules"]),
          _createVNode(FormInput, {
            ref: addFormInputRef,
            modelValue: contact.value.phoneExtension,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contact.value.phoneExtension) = $event)),
            label: _unref(t)('global.phoneExtension'),
            rules: [],
            name: "phoneExtension",
            type: "number",
            onValidated: handleValidation
          }, null, 8, ["modelValue", "label"])
        ]),
        _createVNode(FormInput, {
          ref: addFormInputRef,
          modelValue: contact.value.email,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((contact.value.email) = $event)),
          label: _unref(t)('global.email'),
          name: "email",
          type: "text",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"])
      ]),
      _: 1
    }),
    _createElementVNode("button", _hoisted_5, _toDisplayString(_unref(t)('global.save')), 1)
  ], 40, _hoisted_1))
}
}

})